import { isEmpty, isNone } from '@ember/utils';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';

export default function getUnsubscribedFilters(conditions: SerializedLegacyFilter[] | null, unsubscribed: boolean) {
  let conditionsCopy = isNone(conditions) ? [] : [...conditions];

  if (!unsubscribed) {
    conditionsCopy.push(
      {
        type: 'attribute',
        field: 'unsubscribed',
        operator: '!eq',

        // @ts-ignore: actually coerced to string? for now prefer ts-ignore over global type changes
        value: true,
      },
      {
        type: 'attribute',
        field: 'unsubscribed',
        operator: '!eq',

        // @ts-ignore: actually coerced to string? for now prefer ts-ignore over global type change
        value: 1,
      },
    );
  }

  if (isEmpty(conditionsCopy)) {
    return null;
  }

  return conditionsCopy;
}
